import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { Observable } from 'rxjs';
import { Layer, DnvFeatureLayer } from 'dnv-lib';

@Injectable()
export class LayersService {

  headers: any;
  error: any;
  httpOptions = {
    headers: new HttpHeaders({
      'Cache-Control': 'no-cache',
      Pragma: 'no-cache'
    })
  };

  readonly layersUrl = 'api/';

  constructor(
    private httpClient: HttpClient,
  ) { }

  getLayers(): Observable<Layer[]> {
    return this.httpClient
      .get<Layer[]>(this.layersUrl + 'layers', this.httpOptions);
  }

  // tslint:disable-next-line: max-line-length
  // https://geotoolsprod.cdnv.dnv.ca:6443/arcgis/rest/services/Features_Infrastructure/MapServer/18/query?outFields=%2A&f=json&where=1%3D1&returnDistinctValues=false&returnGeometry=true&spatialRel=esriSpatialRelIntersects
  getGridSelectLayer(dnvFeatureLayer: DnvFeatureLayer, geometry: any[]): Observable<any> {

    const body: any = {
      outFields: '*',
      where: dnvFeatureLayer.whereClause,
      outSR: 4326,
      returnDistinctValues: false,
      returnGeometry: true,
      spatialRel: 'esriSpatialRelIntersects',
      f: 'json'
    };

    if (geometry.length > 0) {
      const geometries = JSON.stringify(
        {
          rings: geometry
        }
      );

      body.geometry = geometries;
      body.geometryType = 'esriGeometryPolygon';
      body.inSR = 4326;
    }


    var url = dnvFeatureLayer.url;
    // tile layers have a different structure in the ArcGIS API, need to use /MapServer/1 to access table info
    if (dnvFeatureLayer.type.toLowerCase() === "tile") {
      url = url + "/1";
    }

    return this.httpClient.post<any>(url + '/query', (new URLSearchParams(body)).toString(), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
        'Cache-Control': 'no-cache',
        Pragma: 'no-cache'
      }
    });
  }
}
